<template>
  <div class="h-100">
    <div class="search">
      <search :o="$data"></search>
    </div>
    <div class="d-flex p-1 pb-2 header">
      <div class="d-flex actions my-auto pl-2">
        <div title="Add selected accounts to a household"
             :class="[
               `btn`,
               `action-button`,
               hasMissingOnDB
                 ? `btn-outline-primary`
                 : `btn-outline-secondary`,
             ]"
             v-on:click="click(`add`, `accounts`)">
          <i class="fas fa-plus-square"></i>
          <span>Import</span>
        </div>
        <div  v-if="isNCA"
             title="Add new NCA account"
             class="btn btn-outline-secondary action-button"
             v-on:click="addNCAAccount()">
          <i class="fas fa-plus-square"></i>
          <span>Add NCA account</span>
        </div>
        <div  v-if="isNCA"
             title="Add new NCA account"
             class="btn btn-outline-secondary action-button"
             v-on:click="updateNCAAccount()">
          <i class="fas fa-plus-square"></i>
          <span>Update account values</span>
        </div>
        <div title="Create Household"
             class="btn btn-outline-secondary action-button"
             v-on:click="click(`create`, `household`)">
          <i class="fas fa-house-user"></i>
          <span>Create Household</span>
        </div>
      </div>
      <div class="d-flex filters my-auto align-items-center">
        <div title="Filter: No Household"
             class="btn action-button"
             :class="classFilter(`div-filter`, `household`)"
             v-on:click="click(`filter`, `household`)">
          <i class="fas fa-filter"
             :class="classFilter(`filter`, `household`)"></i>
          <span>No Household</span>
        </div>
        <div title="Filter: No Contract"
             class="btn action-button"
             :class="classFilter(`div-filter`, `contract`)"
             v-on:click="click(`filter`, `contract`)">
          <i class="fas fa-filter"
             :class="classFilter(`filter`, `contract`)"></i>
          <span>No Contract</span>
        </div>
      </div>
      <div class="flex-grow-1 text-right" style="display: flex; flex-direction: column">
        <span>
          <span v-text="recordsSummary"></span>
          &nbsp;<i v-if="syncing" class="fas fa-sync fa-spin pl-1" title="Syncing custodian accounts..."></i>
        </span>
        <span v-text="selectedText"></span>
      </div>
      <div v-if="ready" class="ml-2 dropdown">
        <button class="btn btn-link text-secondary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-ellipsis-v"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" href="#" @click.prevent="downloadCSV()">
            <i class="fas fa-download mr-2"></i>
            Download CSV
          </a>
          <a class="dropdown-item" href="#" @click.prevent="refresh()">
            <i class="fas fa-sync mr-2"></i>
            Refresh
          </a>
        </div>
      </div>
    </div>
    <template v-if="ready">
    <scroll-area class="pr-3">
      <a ref="download" class="d-none"></a>
      <table class="table table-sm">
        <thead>
          <tr>
            <th>
              <checkbox :o="selectAllState"
                        p="selected"
                        :disabled="disabled(`select-all`)"
                        v-on:change="change(`select`)"></checkbox>
            </th>
            <th>
              <span>Number</span>
              <i class="fas fa-sort pl-1"
                 :class="sortClass(`number`)"
                 v-on:click="sort(`number`)"></i>
            </th>
            <th>
              <span>Name</span>
              <i class="fas fa-sort pl-1"
                 :class="sortClass(`name`)"
                 v-on:click="sort(`name`)"></i>
            </th>
            <th>
              <span>Household</span>
              <i class="fas fa-sort pl-1"
                 :class="sortClass(`household`)"
                 v-on:click="sort(`household`)"></i>
            </th>
            <th>
              <span>Contract</span>
              <i class="fas fa-sort pl-1"
                 :class="sortClass(`contract`)"
                 v-on:click="sort(`contract`)"></i>
            </th>
            <th>
              <span>Value</span>
              <i class="fas fa-sort pl-1"
                 :class="sortClass(`value`)"
                 v-on:click="sort(`value`)"></i>
            </th>
          </tr>
        </thead>
        <tbody :key="bodyKey">
          <tr v-for="(o, index) in items"
              :key="index">
            <td>
              <i title="This account is missing on the most recent custodian data."
                 v-if="o.isMissingOnCustodian"
                 class="fas fa-exclamation-triangle missing-account-icon"></i>
              <checkbox v-else
                        :o="rowCheckStates[o.number] || { selected: false }"
                        p="selected"
                        :disabled="disabled(`select`, o)"
                        v-on:change="change(`select`, o)"></checkbox>
            </td>
            <td>
              <a href="#" class="badge badge-custom"
                    :title="title(`account`)"
                    v-on:click="open(`account`, o)"
                    v-text="o.number"></a>
            </td>
            <td>
              <span v-text="o.name"></span>
            </td>
            <td>
              <template v-if="o.household != NONE">
                <a href="#" class="badge badge-custom"
                      :title="title(`household`)"
                      v-on:click="open(`household`, o)"
                      v-text="o.household"></a>
              </template>
              <template v-else>
                <span v-text="o.household"></span>
              </template>
            </td>
            <td>
              <template v-if="o.contract != NONE">
                <a href="#" class="badge badge-custom"
                      :title="title(`contract`)"
                      v-on:click="open(`contract`, o)"
                      v-text="o.contract"></a>
              </template>
              <template v-else>
                <span v-text="o.contract"></span>
              </template>
            </td>
            <td>
              <span v-text="displayValue(o)" class="value-pill"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </scroll-area>
    </template>
    <template v-else>
      <loading></loading>
    </template>
  </div>
</template>

<style scoped>

.action-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.dropdown-item {
  color: #212529 !important; 
  font-size: 12px;
}

.missing-account-icon {
  color: var(--warning);
  fill: black;
  opacity: 1;
}

div.search {
  margin-right: 1em;
  margin-top: -3em;
  float: right;
  width: 15em;
}

div.header div {
  margin-right: 1em;
  cursor: pointer;
  font-size: 0.8rem;
}

div.header div.records-info {
  cursor: default;
}

div.actions div:hover i,
div.filters i:hover {
  opacity: 1;
}

div.actions {
  border-right: 1px solid gray;
}

div.filters div {
  padding-left: 1em;
}

table span {
  font-size: 0.9rem;
}

span.link {
  cursor: pointer;
  text-decoration: underline;
}

table th:nth-child(2) {
  width: 7em;
}

table td:nth-child(2) {
  white-space: nowrap;
}

table th:nth-last-child(3) {
  width: 22%;
}

table th:nth-last-child(1) {
  width: 8em;
}

table td:nth-last-child(1) {
  text-align: right;
  vertical-align: middle;
}

span.value-pill {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: #e8f1f8;
  border-radius: 1rem;
  font-weight: 600;
  font-size: 0.75rem;
  color: #0c5aa0;
  border: 1px solid #b3d9f2;
}

table th:first-child {
  width: 1em;
}

td {
  vertical-align: inherit;
}

i {
  opacity: 0.3;
}

i:not(.fa-filter):hover,
i.sort,
i.fa-spin,
i.remove,
i.filter {
  cursor: pointer;
  opacity: 1;
}

i.remove {
  color: red;
}
</style>

<script>
import { checkbox, scrollArea, search, loading } from "../../../../component";
import { Api, Component, Csv, lib, List, Modal, Record } from "../../../../factory";
import { numeral } from "../../../../npm";
import { alert, events, session, getActiveScopeFilter, getActiveScopeKey } from "../../../../service";

export default {
  name: `FirmMasterAccounts`,
  get components() {
    return {
      checkbox,
      scrollArea,
      search,
      loading
    };
  },
  data() {
    return {
      _data: { contracts: [], households: [] },
      accountItems: [],
      search: '',
      filterContract: false,
      filterHousehold: false,
      sortKey: '',
      sortAsc: false,
      renderLimit: 500,
      lastSearch: '',
      syncing: false,
      custodian: null,
      bodyKey: 0,
      NONE: '-',
      selectAllState: { selected: false },
      rowCheckStates: {},
      ready: false,
    };
  },
  computed: {
    filteredItems() {
      var search = this.search;

      // Reset render window when search term changes
      if (search !== this.lastSearch) {
        this.renderLimit = 500;
        this.lastSearch = search;
      }

      let filtered = List.filter(this.accountItems, search);
      filtered = this.sortKey === 'value'
        ? this.sortNumeric(filtered, this.sortKey, this.sortAsc)
        : List.sort(filtered, this.sortKey, this.sortAsc);

      return filtered.filter(
        (o) =>
          (!this.filterContract || o.contract == this.NONE) &&
          (!this.filterHousehold || o.household == this.NONE)
      );
    },
    hasMissingOnDB() {
      return this.filteredItems.some((item) => item.missingOnDB);
    },
    items() {
      return this.filteredItems.slice(0, this.renderLimit);
    },
    recordsSummary() {
      return List.records(this.items, this.filteredItems, this.accountItems);
    },
    selectedText() {
      if (!Array.isArray(this.accountItems)) return '';
      var a = this.accountItems.filter((i) => this.rowCheckStates[i.number]?.selected);
      var b = this.accountItems;
      var r = Array.isArray(a) && Array.isArray(b)
        ? [a.length, b.length].map((v) => numeral(v).format(`0,0`))
        : ``;
      return r ? `Selected ${r[0]} of ${r[1]} record(s)` : ``;
    },
    isNCA() {
      return this.custodian?.type?.toLowerCase() == `non-custodial assets`;
    },
  },
  created() {
    // Restore persisted filter/sort/search state
    this._state = Component.state(this, {
      list: {
        filter: { contract: false, household: false },
        search: '',
        sort: { asc: '', key: '' }
      }
    });

    // Restore persistent filter/search/sort state into reactive data properties
    var s = this._state.list;
    this.search = s.search || '';
    this.filterContract = s.filter?.contract || false;
    this.filterHousehold = s.filter?.household || false;
    this.sortKey = s.sort?.key || '';
    this.sortAsc = s.sort?.asc || false;

    // Keep session state in sync when user types in the search field
    this.$watch('search', this.syncStateToSession);

    this.loadData();

    this._scrollUid = events.$on(`scroll`, (e) => {
      var el = e?.data?.target;
      if (!el) return;
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 300) {
        if (this.renderLimit < this.filteredItems.length) {
          this.renderLimit += 500;
        }
      }
    });
  },
  destroyed() {
    if (this._scrollUid) events.$off(this._scrollUid);
  },
  methods: {
    async loadData() {
      var vue = this;
      var state = session.get(`state`);
      try {
        const scopeFilter = getActiveScopeFilter(state);
        const cacheKey = getActiveScopeKey(state);
        const isRepCodeMode = !!state.repCode;
        var custodian = isRepCodeMode ? { _id: '*' } : state.custodian;
        this.custodian = custodian;

        // Return cached data immediately if available
        if (state._accountsCache?.[cacheKey]) {
          const cached = state._accountsCache[cacheKey];
          this.accountItems = cached.accountItems || cached._items || [];
          this._data = cached._data;
          this.ready = true;
          return;
        }

        // Build accounts URL - filter by active scope (repCode or custodianId)
        const accountsUrl = scopeFilter ? `accounts?${scopeFilter.slice(1)}` : `accounts`;

        var [
          { data: accounts },
          { data: contracts },
          { data: households },
        ] = await Promise.all(
          [
            accountsUrl,
            `contracts`,
            `households?_sort=name`,
          ].map((p) => Api.get(p))
        );

        const accountContractMap = new Map();
        for (const contract of contracts) {
          if (contract.status != 2) continue;
          contract.accounts.forEach((acc) => {
            accountContractMap.set(acc.number, contract);
          });
        }

        this.accountItems = accounts
          .sort((a, b) => (a.number || '').localeCompare(b.number || ''))
          .map((a) => {
            let contract = accountContractMap.get(a.number);
            return Object.freeze({
              _id: a._id,
              number: a.number,
              name: a.name,
              householdId: a.householdId,
              contractId: contract?._id,
              contract: contract ? Record.id(contract) : this.NONE,
              household: a.householdId
                ? households.find((o) => o._id == a.householdId)?.name
                : this.NONE,
              value: a.value,
              valueAsOf: a.date,
              custodianId: a.custodianId,
              fundedDate: a.fundedDate,
              repCode: a.repCode,
            });
          });

        this._data.contracts = contracts;
        this._data.households = households;

        // Init rowCheckStates for all accounts
        const states = {};
        this.accountItems.forEach(a => {
          states[a.number] = { selected: false };
        });
        this.rowCheckStates = states;

        this.ready = true;

        // Skip custodian sync when viewing by repCode
        if (isRepCodeMode) {
          this.syncing = false;
          state._accountsCache = state._accountsCache || {};
          state._accountsCache[cacheKey] = {
            accountItems: this.accountItems,
            _data: this._data,
          };
          return;
        }

        this.syncing = true;
        var r;
        const custodianType = custodian?.type?.toLowerCase();
        switch (custodianType) {
          case undefined: {
            try {
              r = state._diffAllPromise
                ? await state._diffAllPromise
                : await Api.get(`/custodian-accounts/diff-all`);
              state._diffAllPromise = null;

              if (r?.data?.accountsNotOnDB?.length) {
                var sAccounts = r.data.accountsNotOnDB
                  .filter((a) => !this.accountItems.find((o) => a.number == o.number))
                  .map((a) => {
                    var name = a.name
                      .split(` `)
                      .map((s) => {
                        switch (s.toUpperCase()) {
                          case `SEP-IRA`: case `IRA`: case `DTD`: case `U/A`: return s;
                          default: return s.includes(`/`) && s.length >= 8 ? `` : lib.string.capitalize(s);
                        }
                      })
                      .join(` `);
                    return Object.freeze({
                      number: a.number,
                      name,
                      master: a.master,
                      contract: this.NONE,
                      household: this.NONE,
                      missingOnDB: true,
                      custodianId: a.custodianId,
                    });
                  });
                this.accountItems.push(...sAccounts);
                sAccounts.forEach(a => {
                  vue.$set(this.rowCheckStates, a.number, { selected: false });
                });
              }

              if (r?.data?.accountsNotOnCustodian?.length) {
                const notOnCustodian = new Set(
                  r.data.accountsNotOnCustodian.map((acc) => acc.number)
                );
                this.accountItems.forEach((account, index) => {
                  if (notOnCustodian.has(account.number)) {
                    vue.$set(this.accountItems, index, Object.freeze({ ...account, isMissingOnCustodian: true }));
                  }
                });
              }
            } catch (error) {
              console.error(error);
            }
            break;
          }
          case `td`:
          case `ipx`:
          case `warren averett`:
          case `schwab`:
          case `fidelity`:
            try {
              r = await Api.get(`/custodian-accounts?custodianType=${custodianType}&master=${custodian.id}`);

              if (r?.data?.accountsNotOnDB?.length) {
                var sAccounts = r.data.accountsNotOnDB
                  .filter((a) => !this.accountItems.find((o) => a.number == o.number))
                  .map((a) => {
                    var name = a.name
                      .split(` `)
                      .map((s) => {
                        switch (s.toUpperCase()) {
                          case `SEP-IRA`: case `IRA`: case `DTD`: case `U/A`: return s;
                          default: return s.includes(`/`) && s.length >= 8 ? `` : lib.string.capitalize(s);
                        }
                      })
                      .join(` `);
                    return Object.freeze({
                      number: a.number,
                      name,
                      master: a.master,
                      contract: this.NONE,
                      household: this.NONE,
                      missingOnDB: true,
                      custodianId: custodian._id,
                    });
                  });
                this.accountItems.push(...sAccounts);
                sAccounts.forEach(a => {
                  vue.$set(this.rowCheckStates, a.number, { selected: false });
                });
              }

              if (r?.data?.accountsNotOnCustodian?.length) {
                const notOnCustodian = new Set(
                  r.data.accountsNotOnCustodian.map((acc) => acc.number)
                );
                this.accountItems.forEach((account, index) => {
                  if (notOnCustodian.has(account.number)) {
                    vue.$set(this.accountItems, index, Object.freeze({ ...account, isMissingOnCustodian: true }));
                  }
                });
              }
            } catch (error) {
              console.error(error);
            }
            break;
          case `non-custodial assets`:
            break;
        }
      } catch (e) {
        console.error(e);
        alert.error(e.message);
      }
      this.syncing = false;
      this.ready = true;

      // Cache the fully-loaded result
      state._accountsCache = state._accountsCache || {};
      state._accountsCache[getActiveScopeKey(state)] = {
        accountItems: this.accountItems,
        _data: this._data,
      };
    },
    reload() {
      events.$emit(`nav`, `accounts`);
    },
    syncStateToSession() {
      if (!this._state) return;
      this._state.list = {
        filter: { contract: this.filterContract, household: this.filterHousehold },
        search: this.search,
        sort: { key: this.sortKey, asc: this.sortAsc }
      };
    },
    refresh() {
      const state = session.get('state');
      const cacheKey = getActiveScopeKey(state);
      if (cacheKey && state._accountsCache) {
        delete state._accountsCache[cacheKey];
      }
      state._diffAllPromise = null;
      this.reload();
    },
    sortNumeric(arr, key, asc) {
      return arr.sort((a, b) => {
        const vA = typeof a[key] === 'number' ? a[key] : -Infinity;
        const vB = typeof b[key] === 'number' ? b[key] : -Infinity;
        return asc ? vA - vB : vB - vA;
      });
    },
    async loadHouseholdDetails(household) {
      try {
        const { data } = await Api.get(`households/${household._id}`);
        return data;
      } catch (error) {
        console.error(`Error loading household details:`, error);
        return household;
      }
    },
    change(type, item) {
      switch (type) {
        case `select`:
          if (!item) {
            // Header checkbox: select/deselect items without _id (not yet in DB)
            const newState = this.selectAllState.selected;
            this.filteredItems
              .filter((o) => !o.hasOwnProperty(`_id`))
              .forEach((o) => {
                this.$set(this.rowCheckStates, o.number, { selected: newState });
              });
          }
          this.bodyKey += 1;
          break;
        default:
          throw new Error(`Invalid change type, ${type}!`);
      }
    },
    classFilter(type, d) {
      var isActive = d === 'contract' ? this.filterContract : this.filterHousehold;
      switch (type) {
        case `filter`:
          return isActive ? `filter` : ``;
        case `div-filter`:
          return isActive ? `btn-primary` : `btn-outline-secondary`;
        case `sort`:
          return this.sortKey == d ? `sort` : ``;
        default:
          throw new Error(`Invalid class type, ${type}!`);
      }
    },
    sortClass(key) {
      return this.sortKey === key ? 'sort' : '';
    },
    addNCAAccount() {
      var state = session.get('state');
      return Modal.open(`NCA-account-add`, {
        custodian: state.custodian,
        methods: {
          success: () => {
            Modal.close();
            this.refresh();
          },
        },
      });
    },
    updateNCAAccount() {
      var state = session.get('state');
      return Modal.open(`NCA-account-update`, {
        custodian: state.custodian,
        accounts: this.accountItems.map(a => a.number),
        methods: {
          success: () => {
            Modal.close();
            this.refresh();
          },
        },
      });
    },
    async click(type, d) {
      switch (type) {
        case `add`:
          var accounts = this.filteredItems.filter((o) => this.rowCheckStates[o.number]?.selected);
          if (!accounts.length)
            return alert.warning(`Sorry, no account(s) have been selected!`, 3e3);
          var { data: households } = await Api.get(`households?_sort=name`);
          this._data.households = households;

          return Modal.open(`custodian-accounts`, {
            accounts,
            custodian: this.custodian,
            households,
            methods: {
              success: () => {
                Modal.close();
                this.refresh();
              },
            },
          });
        case `create`:
          return Modal.open(`household`);
        case `filter`:
          if (d === 'contract') this.filterContract = !this.filterContract;
          else this.filterHousehold = !this.filterHousehold;
          this.syncStateToSession();
          this.renderLimit = 500;
          break;
        default:
          throw new Error(`Invalid click type, ${type}!`);
      }
    },
    displayValue(o) {
      return typeof o.value === 'number' ? numeral(o.value).format(`$0,0.00`) : this.NONE;
    },
    disabled(type, d) {
      switch (type) {
        case `select-all`:
          return this.filteredItems.every((item) => item.hasOwnProperty(`_id`));
        case `select`:
          return d.hasOwnProperty(`_id`) && d.householdId != undefined;
        default:
          throw new Error(`Invalid disabled type, ${type}!`);
      }
    },
    async open(type, d) {
      switch (type) {
        case `account`:
          return Modal.open(`account`, {
            account: {
              ...d,
              isListedUnderCustodian: true
            },
            methods: {
              success: () => {
                Modal.close();
                this.refresh();
              },
            },
            NONE: this.NONE,
          });
        case `contract`:
          var contract = this._data.contracts.find((o) => o._id == d.contractId);
          return Modal.open(`contract`, {
            contract,
            methods: {
              success: () => {
                Modal.close();
                this.refresh();
              },
            },
          });
        case `household`:
          var household = this._data.households.find((o) => d.household == o.name);
          const loadedHousehold = await this.loadHouseholdDetails(household);
          return Modal.open(`household`, {
            household: loadedHousehold,
            methods: {
              success: () => {
                Modal.close();
                this.refresh();
              },
            },
          });
        default:
          throw new Error(`Invalid open type, ${type}!`);
      }
    },
    sort(key) {
      this.sortAsc = this.sortKey == key
        ? typeof this.sortAsc == `boolean` ? !this.sortAsc : true
        : true;
      this.sortKey = key;
      this.syncStateToSession();
    },
    title(type) {
      switch (type) {
        case `account`:
        case `contract`:
        case `household`:
          return `View ${type}`;
        case `records`:
          return `View account records`;
        default:
          throw new Error(`Invalid title type, ${type}!`);
      }
    },
    householdsWithActiveContracts() {
      return new Set(
        this._data.contracts
          .filter((c) => c.status === 2)
          .map((c) => c.householdId)
          .filter(Boolean),
      );
    },
    downloadCSV() {
      const householdsWithContracts = this.householdsWithActiveContracts();
      const headers = ["Account Number", "Account Name", "Household Name", "Household Has Active Contract", "Value", "As Of Date"];
      const data = this.filteredItems.map((acc) => [
        acc.number,
        acc.name,
        acc.household || "",
        acc.householdId && householdsWithContracts.has(acc.householdId) ? "Yes" : "No",
        this.displayValue(acc),
        acc.valueAsOf || "",
      ]);
      Csv.download("accounts.csv", headers, data);
    },
  },
};
</script>
